<div class="container py-4">
  <app-breadcrumbs
    [items]="[
      { label: 'Buscar Clientes', url: '/cliente' },
    ]">
  </app-breadcrumbs>
  <!-- Botón volver -->
  <div class="d-flex align-items-center gap-2 mb-3">
    <button class="btn btn-outline-secondary" (click)="volverAtras()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <h3 class="text-success mb-0">
      <i class="fa-solid fa-users me-2"></i>Gestión de Clientes
    </h3>
  </div>

  <!-- Card de gestión -->
  <div class="card shadow-sm border-0">
    <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        <i class="fa-solid fa-users me-2"></i>Clientes
      </h5>
      <button class="btn btn-light btn-sm" (click)="nuevoCliente()">
        <i class="fa-solid fa-plus me-1"></i>Nuevo cliente
      </button>
    </div>
    <div class="card-body">
      <!-- Buscador -->
      <div class="input-group mb-4">
        <span class="input-group-text bg-light">
          <i class="fa-solid fa-search"></i>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre o código"
          [(ngModel)]="searchTerm"
          (input)="buscarClientes()"
        />
      </div>

      <!-- Tabla de clientes -->
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="table-light">
            <tr>
              <th style="width: 10%">ID</th>
              <th>Nombre Cliente</th>
              <th class="text-center" style="width: 35%">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cliente of clientes">
              <td class="fw-bold">{{ cliente.clienteId }}</td>
              <td>{{ cliente.nombre }}</td>
              <td class="text-center">
                <div class="btn-group btn-group-sm" role="group">
                  <button
                    class="btn btn-outline-primary"
                    title="Ver libreta del cliente"
                    (click)="mostrarLibreta(cliente.clienteId)">
                    <i class="fa-solid fa-eye"></i>
                  </button>
                  <button
                    class="btn btn-outline-success"
                    title="Ver pagos del cliente"
                    (click)="verPagos(cliente.clienteId)">
                    <i class="fa-solid fa-receipt"></i>
                  </button>
                  <button
                    class="btn btn-outline-warning"
                    title="Editar cliente"
                    (click)="editarCliente(cliente.clienteId)">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                  <button
                    class="btn btn-outline-danger"
                    title="Eliminar cliente"
                    (click)="eliminarCliente(cliente.clienteId)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="clientes.length === 0">
              <td colspan="3" class="text-center text-muted">No se encontraron clientes.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
